import React from "react";

const IconChevronLeft = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 8.23 14.459">
      <path
        id="chevron-down"
        d="M11.631,5.815,5.815,0,0,5.815"
        transform="translate(1 13.045) rotate(-90)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
    </svg>
  );
};

export default IconChevronLeft;
